import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center mt-10" }
const _hoisted_2 = { class: "col-md-9 col-sm-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12 col-sm-12 text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title text-center fs-1" }, [
  /*#__PURE__*/_createTextVNode(" Hacking Club Leader Board "),
  /*#__PURE__*/_createElementVNode("span", { class: "bi-trophy bi fs-3" })
], -1)
const _hoisted_9 = { class: "text-center text-gray-800" }
const _hoisted_10 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_11 = { class: "badge badge-lg badge-light-primary fs-6 px-4 py-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-badge me-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Sua posição: ")
const _hoisted_14 = { class: "ms-1" }
const _hoisted_15 = { class: "col-md-12 col-sm-12" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "mt-10" }
const _hoisted_19 = { class: "table table-responsive table-striped table-row-bordered table-row-gray-300 align-middle gs-6 gy-3" }
const _hoisted_20 = { class: "fs-6 fw-bold text-gray-700 border-bottom border-top" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { class: "ps-4 py-3 min-w-10px text-start" }, "# Rank", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { class: "p-0 py-3 min-w-10px text-start" }, "  Player", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "p-0 py-3 min-w-60px text-start" }, null, -1)
const _hoisted_24 = { class: "pe-4 py-3 min-w-20px text-end" }
const _hoisted_25 = {
  key: 0,
  style: {"font-size":"20px"}
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 1°  ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  style: {"color":"#ffd700","font-size":"20px"}
}, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  style: {"font-size":"20px"}
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 2°  ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  style: {"color":"#c0c0c0","font-size":"20px"}
}, null, -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  style: {"font-size":"20px"}
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 3°  ")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  style: {"color":"#cd7f32","font-size":"20px"}
}, null, -1)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 3,
  style: {"font-size":"20px"}
}
const _hoisted_38 = { class: "" }
const _hoisted_39 = ["title"]
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 0,
  class: "pulse pulse-success position-absolute ms-10",
  style: {"left":"0","top":"0"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot bg-success h-10px w-10px" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", {
  class: "pulse-ring position-absolute border-3",
  style: {"left":"-15px","top":"-11px"}
}, null, -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = ["title", "src"]
const _hoisted_46 = { class: "text-muted fw-bold d-block" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "ms-2 mt-2 italic" }
const _hoisted_49 = { class: "text-muted fw-bold d-block" }
const _hoisted_50 = { class: "text-muted fw-bold d-block" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "bi bi-droplet text-danger fs-6" }, null, -1)
const _hoisted_52 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-500 mb-4",
  title: "The most valuable hacker on the platform"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" MVH ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-info" }, null, -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { class: "text-end" }
const _hoisted_57 = { class: "card-title mt-5" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted ms-2" }, "XP", -1)
const _hoisted_59 = { class: "progress-lb col-md-12 mt-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = {
  key: 0,
  class: "d-flex justify-content-center mt-6"
}
const _hoisted_62 = { class: "pagination" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.rank.rank_title_desc`)), 1),
                (_ctx.userRank)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        _hoisted_12,
                        _hoisted_13,
                        _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.userRank) + "°", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("table", _hoisted_19, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_20, [
                          _hoisted_21,
                          _hoisted_22,
                          _hoisted_23,
                          _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.rank.progress_next_level`)), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoreboard, (leader, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: _normalizeClass(["bg-hover-lighten", leader.user.id === _ctx.user.id ? '' : '']),
                            key: index
                          }, [
                            (leader.user_position == 1)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_25, _hoisted_28))
                              : _createCommentVNode("", true),
                            (leader.user_position == 2)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_29, _hoisted_32))
                              : _createCommentVNode("", true),
                            (leader.user_position == 3)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_33, _hoisted_36))
                              : _createCommentVNode("", true),
                            (leader.user_position > 3)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(leader.user_position) + "°   ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_38, [
                              _createElementVNode("div", {
                                class: "position-relative symbol symbol-circle symbol-45px pulse",
                                "data-bs-toggle": "tooltip",
                                "data-bs-boundary": "window",
                                "data-bs-placement": "top",
                                title: leader.user.nick
                              }, [
                                _createElementVNode("img", {
                                  src: leader.user.avatar,
                                  alt: "img"
                                }, null, 8, _hoisted_40),
                                (leader.user.id === _ctx.user.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_44))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_39)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_router_link, {
                                to: { name: 'profile-user', params: { id: leader.user.id } },
                                class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(leader.user.nick || 'No nick') + " ", 1),
                                  _createElementVNode("img", {
                                    title: leader.user.user_patent?.name,
                                    src: '/media/logos/badges/' + leader.user.user_patent?.icon,
                                    class: "h-20px align-self-center",
                                    alt: ""
                                  }, null, 8, _hoisted_45)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("img", {
                                    src: '/media/logos/badges/' + _ctx.userPatent(leader?.user?.score?.value).icon,
                                    class: "h-20px align-self-center",
                                    alt: ""
                                  }, null, 8, _hoisted_47)
                                ]),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.userPatent(leader?.user?.score?.value).name), 1)
                              ]),
                              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.level`)) + " " + _toDisplayString(_ctx.scoreLevel(leader.value).level), 1),
                              _createElementVNode("span", _hoisted_50, [
                                _createTextVNode(_toDisplayString(leader.first_blood_count) + " First Blood ", 1),
                                _hoisted_51
                              ]),
                              (Number(index) + 1 == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_55))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_56, [
                              _createElementVNode("h6", _hoisted_57, [
                                _createTextVNode(_toDisplayString(leader.value) + " ", 1),
                                _hoisted_58,
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("div", {
                                    class: "progress-value-lb bg-success",
                                    style: _normalizeStyle([{"margin-left":"-3px"}, 'width: ' + Math.min((Number(leader.value) / Number(_ctx.maxScore)) * 100, 100) + '%'])
                                  }, null, 4)
                                ]),
                                _hoisted_60
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    (_ctx.totalPages > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("ul", _hoisted_62, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                              _createElementVNode("a", {
                                class: "page-link",
                                href: "#",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)), ["prevent"]))
                              }, _hoisted_64)
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                              }, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                                }, _toDisplayString(page), 9, _hoisted_65)
                              ], 2))
                            }), 128)),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                              _createElementVNode("a", {
                                class: "page-link",
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)), ["prevent"]))
                              }, _hoisted_67)
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}